module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURZ+fn0dwTJmZmZmZmZmZmZmZmerPtBYAAAAFdFJOUxAA0c+913LKhAAAAExJREFUGNNjEEQCDFTmiBhAWMyOIE4wI4gtYAriCJiCpZiBYgwQCiLEAKXBIgwQFRC1DGC9BmAJiD3MIRBDGCDGQoyHuIDZgCb+QQIA9SYWyVyk3NEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/down.png
// module id = QmFs
// module chunks = 34